// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"445":"1bfc9850","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"445":"7343214f9a2130abda93","691":"47c3136a9f095487a80e"}[chunkId] + ".js";
};